export default __webpack_public_path__ + "img/nl.b2493eb3.svg";